import React from "react";
import { FaTimes } from "react-icons/fa";
import { BlackButton, ButtonBase } from "./Buttons";
import Modal from "./Modal";
import Row from "./Row";
import { H1, P } from "./Typography";

const ModalConfirm = ({ onClose, title = "Confirm", description, confirmButtonTitle = 'delete', onConfirm, zindex }) => {
    return (
        <Modal show size="33%" zindex={zindex}>
            <Row>
                <H1>{title}</H1>
                <ButtonBase onClick={onClose} style={{ marginLeft: 'auto' }}><FaTimes size='16px' color="#000" /></ButtonBase>
            </Row>

            <P dangerouslySetInnerHTML={{ __html: description }} />
            <BlackButton onClick={onConfirm}>{confirmButtonTitle}</BlackButton>
        </Modal>
    );
};

export default ModalConfirm;
